'use client';

import { Link } from 'core/i18n/navigation';
import Head from 'next/head';
import { appRoutes } from 'config';
import { type LegalSlug } from 'core/legal';

const TITLES: Record<LegalSlug, string> = {
  'privacy-policy': 'Privacy Policy',
  'terms-of-use': 'Terms of Use',
  'facebook-data-deletion': 'Facebook Data Deletion',
};

// Shown when a legal document isn't published for the active locale. We never
// silently substitute another locale's text — we say so and point to the
// default (English) version.
export const LegalUnavailable = ({ slug }: { slug: LegalSlug }) => {
  const title = TITLES[slug];
  const defaultHref = `/legal/${slug}`;

  return (
    <div className="pt-16 font-inter text-mf-off-black-950">
      <Head>
        <title>{`${title} · MindFeed`}</title>
        <meta name="robots" content="noindex" />
      </Head>
      <div className="mx-auto flex min-h-[60vh] max-w-[560px] flex-col items-center justify-center px-5 text-center">
        <h1 className="font-inter text-3xl font-extrabold tracking-[-0.02em] text-mf-off-black-950 sm:text-4xl">
          {title}
        </h1>
        <p className="mt-4 text-[15px] leading-7 text-mf-gray-600">
          This document isn&apos;t available in your language yet. The binding
          version is the English one — you can read it below.
        </p>
        <Link
          href={defaultHref}
          className="mt-7 inline-flex items-center rounded-full bg-mf-blue px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-mf-blue/90"
        >
          Read the English version
        </Link>
        <Link
          href={appRoutes.HOME}
          className="mt-4 text-sm font-medium text-mf-blue hover:underline"
        >
          Back to home
        </Link>
      </div>
    </div>
  );
};
